var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopySmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "copy-small-a",
    d: "M9.93332833,4 C10.5226515,4 11,4.49723829 11,5.1111169 L11,5.1111169 L11,12.8888831 C11,13.5027878 10.5226515,14 9.93332833,14 L9.93332833,14 L4.06667167,14 C3.47732351,14 3,13.5027617 3,12.8888831 L3,12.8888831 L3,5.1111169 C3,4.49721225 3.47734851,4 4.06667167,4 L4.06667167,4 Z M9.93332833,5.1111169 L4.06667167,5.1111169 L4.06667167,12.8888831 L9.93332833,12.8888831 L9.93332833,5.1111169 Z M12.8571352,1 C13.4885809,1 14,1.50342773 14,2.12500659 L14,10 L12.8571352,10 L12.8571352,2.12500659 L6,2.12500659 L6,1 L12.8571352,1 Z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#copy-small-a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopySmall);
export default __webpack_public_path__ + "static/media/copy-small.589cd696ddf98d5e94fa3ff7dd646310.svg";
export { ForwardRef as ReactComponent };